var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 84,
    viewBox: "0 0 91 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3736_5374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5 10.8889C37.0429 10.8889 30.1875 17.7443 30.1875 26.2014C30.1875 33.0386 40.1953 45.5 44.0295 50.0233C44.8061 50.9396 46.1951 50.9396 46.9705 50.0233C50.8047 45.5 60.8125 33.0386 60.8125 26.2014C60.8125 17.7443 53.9571 10.8889 45.5 10.8889ZM45.5 31.3056C42.6806 31.3056 40.3958 29.0209 40.3958 26.2014C40.3958 23.382 42.6806 21.0972 45.5 21.0972C48.3194 21.0972 50.6042 23.382 50.6042 26.2014C50.6042 29.0209 48.3194 31.3056 45.5 31.3056ZM12.9451 37.1328C12.2235 37.4215 11.6048 37.9197 11.169 38.5633C10.7332 39.2068 10.5002 39.9662 10.5 40.7434V71.1643C10.5 72.54 11.8891 73.4806 13.1663 72.9702L29.9444 65.3334V37.0077C28.8701 35.0657 27.9915 33.1747 27.362 31.3663L12.9451 37.1328ZM45.5 54.5988C43.7901 54.5988 42.1726 53.8478 41.063 52.5377C38.6738 49.7183 36.1326 46.5075 33.8333 43.2141V65.3321L57.1667 73.1099V43.2153C54.8674 46.5075 52.3274 49.7195 49.937 52.5389C48.8274 53.8478 47.2099 54.5988 45.5 54.5988ZM77.8337 30.4743L61.0556 38.1111V73.1111L78.0549 66.3117C78.7766 66.0231 79.3953 65.525 79.8312 64.8814C80.267 64.2378 80.5 63.4783 80.5 62.7011V32.2802C80.5 30.9045 79.1109 29.9639 77.8337 30.4743Z",
    fill: "#D4D8D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3736_5374",
    x: 0.5,
    y: -3,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.847059 0 0 0 0 0.847059 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3736_5374"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3736_5374",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarked);
export default __webpack_public_path__ + "static/media/map-marked.1f326114a84b4caa5695caefbe154eeb.svg";
export { ForwardRef as ReactComponent };